import { render, staticRenderFns } from "./WorkHeaderOpenWindowsBadge.vue?vue&type=template&id=14f50c20"
import script from "./WorkHeaderOpenWindowsBadge.vue?vue&type=script&lang=js"
export * from "./WorkHeaderOpenWindowsBadge.vue?vue&type=script&lang=js"
import style0 from "./WorkHeaderOpenWindowsBadge.vue?vue&type=style&index=0&id=14f50c20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports